import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';
// let inject = [
//   '$scope',
//   'DetailZoneService',
//   '$state',
//   '$rootScope',
//   'SharedService',
//   '$uibModal',
//   'DetailedPaymentService',
//   'AdvanceService'
// ];
let inject = [
  '$scope',
  'DetailZoneService',
  '$state',
  '$rootScope',
  'SharedService',
  '$uibModal',
  'DetailedPaymentService',
  'SessionService',
  
];

class DetailZoneController{
  // constructor ($scope, DetailZoneService, $state, $rootScope, SharedService, $uibModal, DetailedPaymentService, AdvanceService) {
  constructor ($scope, DetailZoneService, $state, $rootScope, SharedService, $uibModal, DetailedPaymentService, SessionService) {
    this.$state = $state;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.DetailedPaymentService = DetailedPaymentService;
    this.SessionService = SessionService;
    // this.AdvanceService = AdvanceService;
    this.$uibModal = $uibModal;
    this.DetailZoneService = DetailZoneService;
    this.SharedService = SharedService;
    this.loanding = false;
    this.plant = [];
    this.concepts = [];
    this.advance = {};
    this.conceptSelected = null;
    this.openModal = false;
    this.conceptSelected = 2;
    this.payment = {};

 
  }

  $onInit(){

    this.shCtrl.globals.currentUser.activeTap = 0;
    this.getDatas();
    this.copy();

    //this.getBillfold();
  }
  
  getDatas() {
    if(angular.isUndefined(this.shCtrl.globals.currentUser.payCart)){
      this.dataGlobals = this.shCtrl.globals;
      this.dataGlobals.currentUser.payCart = [];
      this.dataGlobals.currentUser.totalCartPay = null;     
      this.SessionService.put('globals', this.dataGlobals);
    }

  }

  prueba(){
    console.log("hola");
  }


  getBillfold(){

    //this.payment = result;
    this.payment.recaudo = 0;
    this.payment.recaudo_total = 0;
    // this.DetailedPaymentService.getBillfold('10018629').then(response => {
    /*this.DetailedPaymentService.getBillfold(this.shCtrl.globals.currentUser.thirdDocumentNumber).then(response => {
      if(!response) response = [];

  
      response.forEach(val => {
        if(angular.isString(val.detalle_valor_documento)) val.detalle_valor_documento = parseInt(val.detalle_valor_documento);
        if(angular.isString(val.detalle_saldo_documento)) val.detalle_saldo_documento = parseInt(val.detalle_saldo_documento);
        this.payment.recaudo += val.detalle_saldo_documento;
        val.valor_recaudo = val.detalle_saldo_documento;
        val.numero_documento = val.detalle_numero_documento;
        val.activate = false;
        if(val.valor_recaudo < 0){
          val.operation = 'Saldo a Favor';
        } else {
          val.operation = 'Pago completo';
        }
      });
      console.log(this.payment.recaudo );
      console.log(this.payment.recaudo_total );
      return;

      this.bills = response.filter(val =>  {return val.detalle_saldo_documento > 0});
      this.getTableHeight = 'height: ' + (30 * this.bills.length) + 'px';
      this.$scope.gridOptions.data = this.bills;
    });*/

  }
  
  submitPayment() {
    if(this.conceptForm.$valid) {
      let today = new Date();
      today = today.toISOString().substring(0,10);
      if(angular.isString(this.advance.valor)) {
        this.advance.valor = this.advance.valor.replace(/[,]/g, '');
        this.advance.valor = parseInt(this.advance.valor);
      }
      let result = {
        advance : this.advance,
        plant : this.plant,
        concepto_id : this.conceptSelected,
        centro_operacion_id : this.plant.id,
        centro_operacion_code : this.reference,
        recaudo_total : this.advance.valor,
        observaciones : this.advance.reference,
        usuario_creacion : this.shCtrl.globals.currentUser.userId,
        fecha_creacion : today,
        facturas : null
      };

      if(this.conceptSelected === 1) {
        // this.AdvanceService.setPayment(result);
        // $location.path('/zona-de-pagos/anticipo');
      } else {
        this.DetailedPaymentService.setPayment(result);
        this.$state.go('home.detailedPayment');
      }
      
    }
  }

  messageResponse (options, callAcept, callback, callCancel, callbackCancel) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller : 'ModalResponseController',
      controllerAs : 'mdCtrl',
      size: options.size,
      resolve : {
        modalOptions : () => options
      }
    });
    modalInstance.result.then(() => {
      if(callAcept) {
        callback();
      }
    }).catch(reason => {
      if(callCancel) {
        callbackCancel();
      }
    });
  }
  copy(){
    angular.copy(this.shCtrl.globals.currentUser,this.shCtrl.globals.currentClient);
  }
}

DetailZoneController.$inject = inject;

export default DetailZoneController;




/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/pay-zone/detail-zone/detail-zone.controller.js
 **/